export default {
  list: {
    maxHeight: 315,
    overflow: 'auto',
  },
};
